import { conceptMarkForTerm } from "./inline-logos/conceptMarks";

export { conceptMarkById } from "./inline-logos/conceptMarks";

/** 考え方の印 (墨 1 色の手描き)。線も面も字の色。本文の語の前の印と同じ形 */
export function ConceptSvg({ mark }: { mark: { id: string; d: string; fill?: string; body?: string; lines?: { d: string; w: number }[] } }) {
  return (
    <svg
      className="ilogo"
      data-ilogo={mark.id}
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {mark.body ? <path className="ilogo-m" d={mark.body} /> : null}
      <path d={mark.d} />
      {mark.lines?.map((line) => (
        <path key={line.d} d={line.d} strokeWidth={line.w} />
      ))}
      {mark.fill ? <path d={mark.fill} fill="currentColor" /> : null}
    </svg>
  );
}

/**
 * 技術の名前 (TypeScript、React など) の前に置く小さな印。本文の語の前の印と同じ対応表 (map.json) と同じ形を引く。
 * 対応表に無い語 (Express、Recharts など) は null を返し、字だけにする。
 * alt は別の呼び名 (略称、英名)。name で引けなければ順に引く。
 * 高さは字の 1em、語との間は呼び出し側が 0.25em で空ける (.ilogo の margin-inline-end)
 */
export function TechMark({ name, alt }: { name: string; alt?: Array<string | null | undefined> }) {
  const mark = conceptMarkForTerm(name, ...(alt ?? []).map((a) => a ?? undefined));
  return mark ? <ConceptSvg mark={mark} /> : null;
}
